import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { FiPlusCircle } from 'react-icons/fi';
import useModal from 'hooks/useModal';
import { DocRequestTemplateCategoryType } from 'types/DocRequestTemplate';
import { useTranslation } from 'react-i18next';
import CreateRequestModal from '../CreateRequestModal';

type BtnCreateRequestProps = {
  category: DocRequestTemplateCategoryType
  reloadData: () => void,
};

function BtnCreateRequest( { category, reloadData }: BtnCreateRequestProps ) {
  const { t } = useTranslation();

  const {
    showModal: showCreateRequestModal,
    closeModal: closeCreateRequestModal,
    openModal: openCreateRequestModal,
  } = useModal();

  return (
    <>
      <Row className="justify-content-end">
        <Col xs="auto">
          <Button
            variant="link"
            className="px-0"
            size="sm"
            onClick={openCreateRequestModal}
          >
            <FiPlusCircle size={20} className="me-2" />
            {t( 'admin.docs.createRequestBtn' )}
          </Button>
        </Col>
      </Row>

      {showCreateRequestModal && (
      <CreateRequestModal
        category={category}
        onClose={closeCreateRequestModal}
        reloadData={reloadData}
      />
      )}
    </>
  );
}

export default BtnCreateRequest;
